const SingleCompanyAward = ({ container, award }) => {

    const getPeriodDescription = (month, year) => {
        const date = container.localeManager.moment().month(month - 1).year(year);
        return date.format("MMMM YYYY");
    };

    return (
        <div className="company-award-card">
            <div className="company-award-icon-wrap">
                <img src={award.icon} className="company-award-icon" alt="" />
            </div>
            <div className="company-award-body">
                <span className="company-award-title">
                    {container.localeManager.strings[`award_${award.stats_type}`]}
                </span>
                <span className="company-award-meta">
                    {getPeriodDescription(award.month, award.year)} &middot; <strong>{award.game.code}</strong>
                </span>
            </div>
        </div>
    );
};

export default SingleCompanyAward;